import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <main className="flex-1">
          <div className="max-w-[1500px] mx-auto px-8 lg:px-12 py-10">
            <Outlet />
          </div>
        </main>
        <Footer variant="app" />
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
